import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import Spinner from 'react-bootstrap/Spinner';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCheck } from '@fortawesome/free-solid-svg-icons';


import 'react-datepicker/dist/react-datepicker.css';
import { useForm, Controller, Feedback } from 'react-hook-form';
import axios from 'axios';
import { URL_EMPLOYEE } from '../../constans/servidor';


import { NavLink, useLocation } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { set } from 'immutable';
let dato = []
let cambiar = false

function FormularioCodigos(props) {
	const { data, Terminales } = props;
	const [myVariable, setMyVariable] = useState('Valor inicial');

	const [errorMessageA, setErrorMessageA] = useState('');
	const [errorMessageB, setErrorMessageB] = useState('');
	const [placa, setPlaca] = useState();
	const [objeto, setObjeto] = useState()
	const [loading, setLoading] = useState(true);
	const [estado, setEstado] = useState(false)
	// const [TerminalesB, setTerminalesB] = useState();

	const [datosCorrectosA, setdatosCorrectosA] = useState(false);
	const [datosCorrectosB, setdatosCorrectosB] = useState(false);
	const {
		control,
		watch,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm();
	const regExpCarro = /^[a-z A-Z]{3}[0-9]{3}$/;
	const regExpCarroR = /^[a-z A-Z]{1}[0-9]{4}$/;
	const regExpCarroA = /^[a-z A-Z]{2}[0-9]{4}$/;
	const regExpCarroV = /^[a-z A-Z]{1}[0-9]{5}$/;
	const regExpMoto = /^[a-z A-Z]{3}[0-9]{2}[a-z A-Z]{1}$/;
	const regExpMotoAntigua = /^[a-z A-Z]{3}[0-9]{2}$/;
	const regExpBicis = /^[Bb]ici[0-9]{3}$/;
	const regExpBici = /^[Bb]ici[0-9]{2}$/;
	useEffect(() => {
		console.log('dataaa');
		console.log(data);

	}, []);

	const verificarPlaca = (placa) => {
		console.log(placa);
		if (
			regExpCarro.test(placa) ||
			regExpCarroR.test(placa) ||
			regExpCarroA.test(placa) ||
			regExpCarroV.test(placa) ||
			regExpMoto.test(placa) ||
			regExpMotoAntigua.test(placa) ||
			regExpBicis.test(placa) ||
			regExpBici.test(placa)
		) {
			console.log('entre');
			setPlaca(true);
		} else {
			setPlaca(false);
		}
	};
	const onSubmit = async (data) => {
		// creas un array vacío
		let body = { // creas un objeto
			nombre_convenio: data.convenio.value,
			cantidad_codigos: data.codigo,
		};
		console.log(body);
		try {
			function reloadPage() {
				window.location.reload();
			}
			const resultado = await axios.post(`${URL_EMPLOYEE}/conveniosVirtuales/spCodesvirtuals`, body)
			if (resultado.data.status) {
				toast.success(resultado.data.message)
				setInterval(reloadPage, 2000);
			} else {
				toast.error(resultado.data.message)

			}

		} catch (error) {
			toast.error('Algo salio mal..');
			setLoading(false);
		}
	}

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Row className={estado ? "azul mbottom-20" : "contenedorF-Filtrado mbottom-200"} >
				{data ? (
						<Col xs={12} sm={4} md={4} lg={4} xl={4}>
							<Form.Group controlId="formBasicEmail">
								<Form.Label className='texto-label'>Nombre Convenio</Form.Label>
								<Controller
									name="convenio"
									control={control}
									rules={{
										required: {
											value: true,
											message: 'El campo es obligatorio',
										}
									}}
									// rules={{ required: true }}
									defaultValue=""
									render={({ field: { onChange, onBlur, value } }) => (
										<Select
											onChange={(data) => {
												onChange(data);
											}}
											value={value}
											// placeholder="Elige una opción"
											options={data}
										/>

									)}
								/>
								{errors.convenio && (
									<Form.Text id="passwordHelpBlock" className="error">
										El campo es obligatorio
									</Form.Text>
								)}
							</Form.Group>
						</Col>
				) : null}
				<Col xs={12} sm={6} md={4} lg={4} xl={4}>
					<Form.Group className="inputmayuscula">
						<Form.Label className='texto-label'>Cantidad de Códigos</Form.Label>
						<Controller
							name="codigo"
							control={control}
							rules={{
								required: {
									value: true,
									message: 'El campo es obligatorio',
								}
							}}
							render={({ field: { onChange, onBlur, value } }) => (
								<Form.Control
									type="number"
									onBlur={onBlur}
									onChange={(value) => onChange(value)}
									value={value}
								/>
							)}
						/>
						{errors.codigo && (
									<Form.Text id="passwordHelpBlock" className="error">
										El campo es obligatorio
									</Form.Text>
								)}
					</Form.Group>
				</Col>

				<Col style={{ marginRight: '20px' }} className="  mbottom-20" xs={12} sm={4} md={4} lg={4} xl={4}>

							<Button style={{ marginRight: '20px' }} type="submit" variant="primary" className=" btn btn-primary mtop-20 boton"
							>
								Crear
							</Button>
						</Col>
			</Row>
		</form>
	);
}

function FormularioMultiple(props) {
	const { Terminales } = props;
	const [loading, setLoading] = useState(true);
	const [datosMultiples, setDatosMultiples] = useState([]);
	const [data, setData] = useState();


	const onSubmit = async (data) => {
		try {
			console.log(data.terminales.value);
			const body = {
				codPark: data.terminales.value
			}
			const resultado = await axios.post(`${URL_EMPLOYEE}/conveniosVirtuales/searchConvenio`, body)
			setLoading(false)
			resul(resultado)

			function resul(resultado) {
				if (resultado.data.status) {
					const objeto = resultado.data.data
					const datos = []

					const nombresConvenio = objeto.map(convenio => ({
						value: convenio.nombre_convenio,
						label: convenio.nombre_convenio
					}));
					setData(nombresConvenio)
				} else {
					toast.error('No se encontro el parquedaero ');

				}
			}
			// reset({
			// 	cod_park: '',
			// });
		} catch (error) {
			toast.error('Algo salio mal..');
			setLoading(false);
		}
	};
	const {
		control,
		watch,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm();

	useEffect(() => {
		setTimeout(() => {
			setLoading(false)
		}, 1000);

	}, []);

	return loading ? (
		<div className="cargando">
			<div className="loader" id="loader">
				Loading...
			</div>
		</div>
	) : (
		<>
			<Container >
				<form onSubmit={handleSubmit(onSubmit)}>
					{Terminales ? (
						<Row className="contenedorT-Filtrado">
							<Col xs={12} sm={4} md={4} lg={4} xl={4}>
								<Form.Group controlId="formBasicEmail">
									<Form.Label className='texto-label'>Parqueadero</Form.Label>
									<Controller
										name="terminales"
										control={control}
										rules={{
											required: {
												value: true,
												message: 'El campo es obligatorio',
											}
										}}
										// rules={{ required: true }}
										defaultValue=""
										render={({ field: { onChange, onBlur, value } }) => (
											<Select
												onChange={(data) => {
													onChange(data);
												}}
												value={value}
												// placeholder="Elige una opción"
												options={Terminales}
											/>

										)}
									/>
									{errors.terminales && (
										<Form.Text id="passwordHelpBlock" className="error">
											El campo es obligatorio
										</Form.Text>
									)}
								</Form.Group>
							</Col>

						</Row>
					) : null}
					<Row className="justify-content-end mbottom-20">
						<Button type="submit" variant="primary" className=" btn btn-primary mtop-20 boton"
						>
							Continuar
						</Button>
					</Row>
				</form>
			</Container>
			{data ? (
				<FormularioCodigos data={data} Terminales={Terminales} />

			) : null}


		</>

	)
}

export default FormularioMultiple;
